import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import * as _ from 'lodash-es';
import { ToastMessageComponent } from '../shared/toast-message/toast-message.component';
import { DialogModeType } from '../shared/error/dialog-message-type.enum';

const defaultDuration = 5000;

@Injectable({ providedIn: 'root' })
export class ToastMessageService {
  
  constructor(private snackBar: MatSnackBar) {
  }

  public show(mode: DialogModeType,
              message: string,
              showDismissalButton: boolean = true,
              duration?: number,
              linkUrl?: { title: string, url: string },
              additionalDetails?: any ): any {

    let action = '';
    if ( showDismissalButton ) {
      action = 'Dismiss';
    }

    // Default duration of 1 sec per word if dismissal button not shown
    if ( _.isNil(duration) && !showDismissalButton ) {
      duration = this.calcDurationMillis(message);
    }

    const config: MatSnackBarConfig = new MatSnackBarConfig();
    config.duration = duration;
    config.politeness = DialogModeType.ERROR === mode ? 'assertive' : 'polite';
    config.panelClass = 'fss-toast-container';
    config.data = {
      message: message,
      additionalDetails: additionalDetails,
      mode: mode,
      action: action,
      linkUrl: linkUrl 
    };

    return this.snackBar.openFromComponent(ToastMessageComponent, config);
  }

  public dismiss() {
    this.snackBar.dismiss();
  }
  
  public calcDurationMillis( msg: string ): number {
    // one sec per word
    const arr = msg.split(' ');
    const d = ( arr.filter(word => word !== '').length ) * 1000;
    return d > 0 ? d : defaultDuration;
  }

}
